import { useEffect } from "react";

import { useAppSelector } from "@/data/hooks";
import { selectIsExam } from "@/features/assignment/assignment-selectors";
import { selectIsUploading } from "@/features/socratic/socratic-slice";
import { selectWritingDatePassed } from "@/features/timeline";
import { selectCanSubmitLateExam } from "@/stores/selectors";

/**
 * Call `onEnd` when the student's writing exam session has ended.
 * Navigation is held while a Socratic video upload is in progress so the
 * upload is not cancelled mid-flight.
 */
export function useRedirectOnExamEnd(onEnd: () => void): void {
  const isExam = useAppSelector(selectIsExam);
  const writingDatePassed = useAppSelector(selectWritingDatePassed);
  const canSubmitLateExam = useAppSelector(selectCanSubmitLateExam);
  const isUploading = useAppSelector(selectIsUploading);

  useEffect(() => {
    if (isExam && writingDatePassed && !canSubmitLateExam && !isUploading) {
      onEnd();
    }
  }, [isExam, writingDatePassed, canSubmitLateExam, isUploading, onEnd]);
}
